import React from 'react';
import './ServiceCard.css';

const ServiceCard = ({ service, onServiceClick }) => {
  const { title, description, image, price, features, rating } = service;

  const handleViewDetails = () => {
    if (onServiceClick && typeof onServiceClick === 'function') {
      onServiceClick();
    }
  };

  return (
    <div className="service-card fade-in" itemScope itemType="https://schema.org/Service">
      <meta itemProp="name" content={title} />
      <meta itemProp="description" content={description || `${title} - Professional camera installation service by Transcontinental Network`} />
      <meta itemProp="provider" content="Transcontinental Network" />
      <div className="service-image">
        {image ? (
          <>
            <img 
              src={image} 
              alt={title ? `${title} - Security Camera & CCTV Installation Service` : 'Camera Installation Service'} 
              loading="lazy"
            />
            <div className="service-overlay">
              <button 
                className="btn btn-primary"
                onClick={handleViewDetails}
              >
                View Details
              </button>
            </div>
          </>
        ) : (
          <div className="no-image-placeholder">
            <div className="no-image-content">
              <svg viewBox="0 0 24 24" width="48" height="48" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.6, marginBottom: '8px' }}>
                <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
                <circle cx="8.5" cy="8.5" r="1.5" />
                <polyline points="21 15 16 10 5 21" />
              </svg>
              <span className="no-image-text">No Image Available</span>
            </div>
            <div className="service-overlay">
              <button 
                className="btn btn-primary"
                onClick={handleViewDetails}
              >
                View Details
              </button>
            </div>
          </div>
        )}
      </div>
      
      <div className="service-content">
        <div className="service-header">
          <h3 className="service-title">{title}</h3>
          <div className="service-rating">
            <span className="rating-stars">
              {Array.from({ length: 5 }, (_, i) => (
                <span key={i} className={`star ${i < Math.floor(rating) ? 'filled' : ''}`}>
                  ★
                </span>
              ))}
            </span>
            <span className="rating-value">({rating})</span>
          </div>
        </div>
        
        <p className="service-description">{description}</p>
        
        <div className="service-features">
          <h4 className="features-title">What's Included:</h4>
          <ul className="features-list">
            {features.map((feature, index) => {
              const cleanFeature = feature.replace(/^[✓✔✅\s]+/, '');
              return (
                <li key={index} className="feature-item">
                  <span className="feature-check">✓</span>
                  {cleanFeature}
                </li>
              );
            })}
          </ul>
        </div>
        
        <div className="service-footer">
          <div className="service-price">{price}</div>
          <div className="service-buttons">
            <button 
              className="btn btn-primary"
              onClick={handleViewDetails}
            >
              View Details
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;